<template>
  <div class="comment-item">
    <div class="header">
      <img class="avatar" :src="comment.avatar" />
      <span class="nickname">{{ comment.nickname }}</span>
      <div style="position: relative">
        <el-rate v-model="comment.grade"></el-rate>
        <div
          style="
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            z-index: 1;
          "
        ></div>
      </div>
      <div style="flex-grow: 1"></div>
      <a
        class="operate delete"
        v-if="$store.state.user_info.id == comment.uid"
        @click="onDelete"
      >
        删除
      </a>
      <a class="operate complaint" v-else @click="onComplaint">举报</a>
    </div>
    <div class="content">{{ comment.content }}</div>
    <div class="time">{{ comment.created_at | tsFormatLong }}</div>
  </div>
</template>

<script>
export default {
  name: "CourseComment",
  props: {
    comment: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    onComplaint() {
      this.$emit("complaint");
    },
    async onDelete() {
      await this.$promiseConfirm("删除后，该内容将不再展示，是否确认？", {
        type: "warning",
      });
      await this.$http.delete("/api/app/course/comment/" + this.comment.id);
      this.$emit("delete");
    },
  },
};
</script>

<style scoped lang="scss">
.comment-item {
  border-bottom: 1px solid #e8e8e8;
  padding: 16px 0;

  &:last-child {
    border-bottom: none;
  }

  .header {
    display: flex;
    align-items: center;
    color: #595959;

    .avatar {
      width: 20px;
      height: 20px;
      border-radius: 100%;
      margin-right: 10px;
    }

    .nickname {
      margin-right: 20px;
      font-size: 16px;
    }

    .el-rate {
      display: inline-block;
    }

    .operate {
      font-size: 14px;
      color: rgba(89, 89, 89, 1);
      cursor: pointer;
      display: none;

      &.delete:hover {
        color: #e74d3d;
      }

      &.complaint:hover {
        color: $primary-color;
      }
    }
  }

  &:hover {
    .header {
      .operate {
        display: block;
      }
    }
  }

  .content {
    padding: 16px 0;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    word-break: break-all;
  }

  .time {
    color: rgba(0, 0, 0, 0.25);
    font-size: 14px;
  }

  /deep/ {
    .el-icon-star-on,
    .el-icon-star-off {
      color: #ea7a2f !important;
    }
  }
}
</style>
